module.exports = __webpack_public_path__ + "img/company_certhree.71583ebc.png";